import {Component} from '@angular/core';
import {SeoService} from '../shared/services/seo.service';

@Component({
  styleUrls: ['./complaint-page.component.scss'],
  templateUrl: './complaint-page.component.html'
})
export class ComplaintPageComponent {
  public title: string;

  constructor(private seoService: SeoService) {
    this.title = 'Μήνυση επί εσχάτη προδοσία';
    this.seoService.addTags('Ενημερώσου για τη μήνυση επί εσχάτη προδοσία που έχει καταθέσει το Ε.ΠΑ.Μ.', 'assets/images/Home.png', this.title);
  }
}
